<template>
    <div class="asset-api-chart">
        <div class="chart" id="assetApiChart"></div>
    </div>
</template>

<script>
// import AssetChart from "@/views/assets/Asset-chart.vue";
import { getAssetChartDatas } from "@/api/api";

export default {
    components: {
        // AssetChart
    },
    props: {
        type: {
            type: String,
            default: 'u'
        }
    },
    data: function () {
        return {
            chartParam: {},
            chartObj: null,
            chartData: null,
        }
    },
    mounted() {
        this.chartObj = this.$echarts.init(document.getElementById('assetApiChart'));
    },
    methods: {
        getChartData(param) {
            this.chartParam = param;
            if (this.chartObj) {
                this.chartObj.showLoading({
                    text: 'loading',
                    color: '#c23531',
                    textColor: '#000',
                    maskColor: '#262829',
                    zlevel: 0
                });
            }
            getAssetChartDatas(this.chartParam).then(res => {
                if (res.code == 200) {
                    this.chartData = res.data;

                    this.updateChart();
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },
        updateChart() {
            const tpe = this.type
            if (!this.chartObj) {
                this.chartObj = this.$echarts.init(document.getElementById('assetApiChart'));
            }
            
            let lineObj = tpe == 'b' ? this.chartData.equity : this.chartData.equity_rate_usdt;
            let formatData = tpe == 'b' ? this.chartData.equity : this.chartData.equity_usdt;
            let legendList = [];
            let seriesList = [];
            let seriesSelected = {};
            for (var i in lineObj) {
                let seriesObj = {
                    name: i == 'total_value'? 'total' : i,
                    type:'line',
                    symbol: 'none',
                    smooth: true,
                    data: lineObj[i],
                    lineStyle: {
                        width: 1.5
                    }
                };
                
                if (i == 'total_value') {
                    if(tpe === 'b') {
                        seriesSelected['total'] = false
                    } else {
                        seriesSelected['total'] = true
                    }
                } else {
                    if(tpe === 'b') {
                        seriesSelected[i] = true;
                    } else {
                        seriesSelected[i] = false;
                    }
                }
                let legend = {
                    name: i == 'total_value'? 'total' : i
                };
                if (i == 'total_value') {
                    // legend['itemStyle'] = {color: "#db5634"}
                }
                legendList.push(legend);
                seriesList.push(seriesObj);
            }

            console.log(legendList, seriesList)

            let chartConfig = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    position: [0, 0],
                    formatter: function (val) {
                        var htmlStr = val[0].axisValue+'</br>';
                        for (let i = 0; i<val.length; i++) {
                            var item = val[i];
                            var iIndex = item.dataIndex;
                            var seriesName = item.seriesName == 'total'? 'total_value': item.seriesName;
                            
                            htmlStr += seriesName+' : '+formatData[seriesName][iIndex] + '<br>';
                        }
                        return htmlStr;
                    }
                },
                title: {
                    textStyle: {
                        fontSize: 14
                    }
                },
                legend: {
                    data: legendList,
                    textStyle: {
                        color: '#db5634',
                        fontSize: 12,
                    },
                    icon: 'roundRect',
                    left: 0,
                    inactiveColor: '#616063',
                    selected: seriesSelected
                },
                grid: {
                    height: '110px',
                    left: '0'
                },
                dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                    height: 20
                }],
                calculable : true,
                xAxis: [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : this.chartData.dateTime,
                        axisLabel: {
                            textStyle: {
                                fontSize: 10,
                                color: '#616063'
                            },
                        },
                        axisTick: {
                            show: false,
                            interval: 2,
                            length: 10,
                            color: '#616063'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#616063',
                                width: 1
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type : 'value',
                        position: 'right',
                        axisLabel : {
                            formatter: tpe === 'b' ? '{value}' : '{value} %',
                            // formatter: value,
                            color: '#616063',
                            fontSize: 10
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#616063',
                            }
                        },
                        splitNumber: 5,
                        splitLine: {
                            show: false
                        }
                    }
                ],
                series: seriesList
            };

            this.chartObj.setOption(chartConfig, true);
            this.chartObj.hideLoading();
        },
        changeChart() {

        },
        dateTimeBgc() {},
        currecncySelect() {},
        currencyHigh() {},
    }
}
</script>

<style lang="scss" scoped>
.asset-api-chart {
    #assetApiChart {
        width: 720px;
        height: 200px;
    }
}
</style>
